import { FC, useEffect, MouseEvent } from "react";
import { useMutation } from "react-query";
import {
  Button,
  CircularProgress,
  Paper,
  TableContainer,
  Typography,
} from "@mui/material";
import { CustomFormField } from "../../utilis/component/CustomFormElement";
import { useForm } from "react-hook-form";
import TableComponent from "../component/TableComponent";
import moment from "moment";
import {
  codificationreportexcelervice,
  codificationreportpdfervice,
  codificationreportsearchservice,
} from "./service";
import useRepotFile from "../hooks/reportFileHook";
const CodificationStatusReport: FC = () => {
  const { control, reset, getValues } = useForm();
  const {
    mutate: getReport,
    data: Data,
    isLoading,
    reset: resetMutation,
  } = useMutation(codificationreportsearchservice);

  const {
    mutate: getcodificationReportpdf,
    isLoading: codificationpdfLoading,
  } = useRepotFile({
    apiFunction: codificationreportpdfervice,
    responseFileKey: "file",
  });

  const {
    mutate: getcodificationReportexcel,
    isLoading: codificationexcelLoading,
  } = useRepotFile({
    apiFunction: codificationreportexcelervice,
    fileType: "xlsx",
  });

  const clearForm = () => {
    reset({
      fromDate: "",
      toDate: "",
    });
    resetMutation();
  };

  const onChange = () => {
    const data = getValues();  
    if(data.fromDate && data.toDate) {
      getReport({ ...data });
    }else{
      resetMutation()
    }
  };

  const getFiles = (e: MouseEvent<HTMLButtonElement>) => {
    const fileType = e.currentTarget.dataset.filetype;
    const allData = getValues();
    if (fileType === "pdf") {
      getcodificationReportpdf({
        fromDate: allData.fromDate,
        toDate: allData.toDate,
      });
    } else {
      getcodificationReportexcel({
        fromDate: allData.fromDate,
        toDate: allData.toDate,
      });
    }
  };

  useEffect(() => {
    getReport({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    });
    reset({
      fromDate: moment().format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    });
  }, []);

  return (
    <div className="px-3 py-4 flex flex-col gap-3">
      <Paper>
        <div className="p-4 border-b">
          <Typography color={"primary"} fontWeight={600} fontSize={"1rem"}>
            codification Status Report
          </Typography>
        </div>
        <form className="grid grid-cols-2 gap-3 p-4">
          <CustomFormField
            control={control}
            element="datepicker"
            name="fromDate"
            fieldProps={{ label: "From Date" }}
            rules={{ required: "From Date is required", onChange }}
          />
          <CustomFormField
            control={control}
            element="datepicker"
            name="toDate"
            fieldProps={{ label: "To Date" }}
            rules={{ required: "From Date is required", onChange }}
          />
          <div className="col-span-full flex justify-end items-center gap-3">
            <Button onClick={clearForm} color="error">
              clear
            </Button>
          </div>
        </form>
      </Paper>

      <TableContainer component={Paper}>
        <div className="flex justify-end gap-3 py-2 px-4 border-b">
          <Button
            disabled={
              codificationpdfLoading || !Boolean(Data?.response?.length)
            }
            endIcon={codificationpdfLoading && <CircularProgress size={18} />}
            data-filetype="pdf"
            onClick={getFiles}
          >
            pdf
          </Button>
          <Button
            disabled={
              codificationexcelLoading || !Boolean(Data?.response?.length)
            }
            endIcon={codificationexcelLoading && <CircularProgress size={18} />}
            data-filetype="excel"
            onClick={getFiles}
          >
            download excel
          </Button>
        </div>
        <TableComponent
          loading={isLoading}
          data={Data?.response || []}
          tableProps={heading}
          paginationChange={(prop) => {
            console.log(prop);
          }}
        />
      </TableContainer>
    </div>
  );
};

export default CodificationStatusReport;
const heading = [
  { heading: "EMR NO/REG NO", key: "patientId" },
  { heading: "PATIENT NAME", key: "patientName" },
  // { heading: "BILLED DATE", key: "createdDate", },
  { heading: "CREATED DATE", key: "createdDate",date:true },
  { heading: "INSURANCE AMOUNT", key: "insAmount" },
  { heading: "PATIENT SHARE", key: "patShare" },
  { heading: "PATIENT TYPE", key: "paymentMode" },
  { heading: "CODIFICATION STATUS", key: "claimStatus" },
];
